import type { ModalSize } from './constants'
import type { ComputedRef } from 'vue'
import { computed } from 'vue'

export default function useModalClassName(
  size: ModalSize
): ComputedRef<string> {
  return computed(() => `sf-modal-${size}`)
}
